<template>
  <div :class="$style.wrap">
    <base-form
      ref="form"
      :items="data"
      label-width="4em"
      submit-text="确定"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
import { mixinForward } from "@/mixins/mixinForward";
import { modifypassword } from "@/http/account";
import BaseForm from "@/components/BaseForm";
export default {
  name: "Password",
  components: {
    BaseForm
  },
  mixins: [mixinForward],
  data() {
    return {
      data: [{ name: "currentPassword" }, { name: "newPassword" }]
    };
  },
  methods: {
    /**
     * @description 修改密码
     * @param {object} formdata  - 表单对象值
     */
    async onSubmit(formdata) {
      let { currentPassword, newPassword } = formdata;
      if (currentPassword == newPassword) {
        this.$Toast("新密码不能与当前密码相同");
        this.$refs.form.disabled = false;
        return false;
      }
      const parmas = {
        old_password: currentPassword,
        new_password: newPassword,
        type: 1
      };
      modifypassword(parmas)
        .then(res => {
          if (res.rcode == 0) {
            this.success("密码修改成功", {
              countdown: true,
              callback: () => {
                if (this.forward) {
                  location.href = this.forward;
                } else {
                  this.$router.replace({ path: this._anchor.profile.path });
                }
              }
            });
          }
        })
        .catch(() => {
          this.$refs.form.disabled = false;
        })
        .finally(() => {
          if (this.$refs.form) {
            this.$refs.form.disabled = false;
          }
        });
    }
  }
};
</script>

<style lang="less" module>
.wrap {
  padding-top: 1.68rem;
}
</style>
